var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1095(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.859,
    height: 100,
    viewBox: "0 0 99.859 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1095",
    "data-name": "Group 1095",
    transform: "translate(512.838 -70.638)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4062",
    "data-name": "Path 4062",
    d: "M-465.837,137.426v6.321h-47V70.657h1.116q48.708,0,97.415-.019c.9,0,1.164.228,1.162,1.15q-.047,18.389-.021,36.779v1.07h-6.343V80.618l-27.4,22.722,9.955,10.818-4.653,4.241-10.385-11.016c-1.411,1.162-2.806,2.3-4.193,3.455-2.115,1.755-4.246,3.493-6.325,5.29-.589.509-.946.429-1.5-.034-3.444-2.9-6.917-5.767-10.476-8.725l-27.94,30.057Zm2.811-28.991,37.883-31.325H-500.7Zm-43.452,24.145,27.334-29.24-27.334-22.667Z",
    fill: "#f18181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4063",
    "data-name": "Path 4063",
    d: "M-261.493,319.978c-.8.845-1.679,1.7-2.466,2.635a1.2,1.2,0,0,0-.027,1.011,11.748,11.748,0,0,1-2.7,13.743c-1.707,1.714-3.4,3.441-5.138,5.125a23.415,23.415,0,0,1-3.046,2.688,11.1,11.1,0,0,1-12.281.663c-4.127-2.274-6.062-5.99-6-10.666a10.43,10.43,0,0,1,2.814-7.144c2.514-2.682,5.1-5.311,7.786-7.815a11.789,11.789,0,0,1,13.8-1.791c.812-.87,1.662-1.745,2.453-2.67.126-.147.064-.554-.04-.782a11.314,11.314,0,0,1,2.3-13.33c2.538-2.567,5.014-5.221,7.756-7.556a11.236,11.236,0,0,1,14.93,0c4.961,4.36,6.117,11.272,1.29,16.565-2.386,2.617-4.936,5.093-7.5,7.544a11.639,11.639,0,0,1-13.511,1.938C-261.149,320.1-261.242,320.072-261.493,319.978Zm-15.572,6.349,3.37-3.173a5.206,5.206,0,0,0-4.145,1.244c-2.448,2.372-4.881,4.763-7.235,7.228a5.521,5.521,0,0,0-.175,7.49,5.308,5.308,0,0,0,7.133.452c2.732-2.5,5.3-5.18,7.861-7.856a4.735,4.735,0,0,0,1.029-4.071l-3.155,3.368Zm20.7-11.226a4.611,4.611,0,0,0,4.375-1.33c2.24-2.21,4.486-4.417,6.67-6.681a5.985,5.985,0,0,0,1.955-4.32,4.677,4.677,0,0,0-3.24-4.447,5.04,5.04,0,0,0-5.574.848c-2.586,2.421-5.066,4.959-7.521,7.515a4.563,4.563,0,0,0-1.242,3.91l.322.234,2.906-3.137,4.607,4.46Z",
    transform: "translate(-176.004 -176.748)",
    fill: "#f18181"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1095);
export default __webpack_public_path__ + "static/media/Group 1095.4c1ef2325f4f9f66a849de618f2b5240.svg";
export { ForwardRef as ReactComponent };